import {
    IGetTransactionsStatData,
    IGetTransactionsStatDataFormatted,
    IGetTransactionsSummaryStatData,
    IGetTransactionsSummaryStatDataFormatted,
} from '@api/types';

export const formatTransactionsResponse = (
    data: IGetTransactionsStatData[],
): IGetTransactionsStatDataFormatted[] => {
    return (
        data?.map(
            ({
                id,
                attributes: {
                    stats_ts: date,
                    order_number: orderNumber,
                    transaction_time: transactionTime,
                    order_status: status,
                    revenue,
                    creative_title: creativeName,
                    offer_id: offerId,
                    sub_title: sub,
                    user_click_id: clickId,
                    product,
                    commission_user: commissionUser,
                    product_link: productLink,
                    advertForm,
                },
            }): IGetTransactionsStatDataFormatted => ({
                id,
                date,
                orderNumber,
                offerId,
                transactionTime,
                status,
                creativeName,
                sub,
                commissionUser,
                revenue,
                product,
                productLink,
                clickId,
                advertForm,
            }),
        ) || []
    );
};

const defaultValue = { count: 0, commission: 0 };

export const formatSummaryResponse = (
    data: IGetTransactionsSummaryStatData,
): IGetTransactionsSummaryStatDataFormatted => {
    const {
        completed = defaultValue,
        pending = defaultValue,
        rejected = defaultValue,
        waiting = defaultValue,
    } = data?.attributes || {};
    return {
        completed,
        pending,
        rejected,
        waiting,
    };
};

export default {
    formatTransactionsResponse,
    formatSummaryResponse,
};
